import { useCallback, useEffect, useState } from "react";
export function useSyncScroll({tableContainerRef, resultsLoaded}:
  {
    tableContainerRef: React.MutableRefObject<HTMLDivElement>;
    resultsLoaded: boolean;
  }) {
  const [tableWidth, setTableWidth] = useState<number>(0);
  const [tableColumnWidths, setTableColumnWidths] = useState<number[]>([]);

  const updateTableDimensions = useCallback(() => {
    if (tableContainerRef.current) {
      const table = tableContainerRef.current.querySelector('table');
      if (table) {
        const firstRowCells = table.querySelector('tr:first-child').children;
        const widths = Array.from(firstRowCells, td => td.clientWidth);
        setTableWidth(table.offsetWidth);
        setTableColumnWidths(widths);
      }
    }
  }, [tableContainerRef.current]);

  useEffect(() => {
    updateTableDimensions();
  }, [tableContainerRef.current, resultsLoaded]);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const current = event.target as HTMLDivElement;
    const scrollLeft = current.scrollLeft;
    requestAnimationFrame(() => {
      if (tableContainerRef.current) {
        tableContainerRef.current.scrollLeft = scrollLeft;
      }
    });
  };

  useEffect(() => {
    const handleResize =() => {
      updateTableDimensions();
    }; 
    const resizeObserver = new ResizeObserver(handleResize);
    if (tableContainerRef.current) {
      resizeObserver.observe(tableContainerRef.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [tableContainerRef.current]);

  return {
    handleScroll,
    tableWidth,
    tableColumnWidths
  };
}

